// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__jUxGc","title":"InfoRow_title__29zaj"};